//React
import React, { useEffect, useRef, useState } from "react";
//Components
import {
  Button,
  Dropdown,
  FlexBox,
  Image,
  Input,
  Modal,
  Screen,
  TranslatedString,
  Code,
  Header,
} from "components";
//Paths
import ROUTE_PATH from "Routes/paths";
//Styles
import "./styles.scss";
//Libraries
import cx from "classnames";
import ResizePanel from "react-resize-panel-ts";
//Assets
import Logo from "assets/logo.svg";
//Utils
import {
  ChangeHistory,
  copyText,
  getURLParameter,
  useIsInViewport,
  validateEmail,
} from "utils";
import secureLocalStorage from "react-secure-storage";
import { toast } from "react-toastify";

const Landing = () => {
  const [orgName, setOrgName] = useState("");
  const [orgDomain, setOrgDomain] = useState("");
  const [emailValue, setEmailValue] = useState("");
  const [copyButtonText, setCopyButtonText] = useState("Copy Code");
  const [activeCodeTab, setActiveCodeTab] = useState("Step 1");
  const [isScrollRouteAllowed, setIsScrollRouteAllowed] = useState(true);
  const [apiKeysModalVisiblity, setApiKeysModalVisiblity] = useState(false);
  const [showButtonLoader, setButtonShowLoader] = useState(false);
  const [activeLanguageTab, setActiveLanguageTab] = useState("Java");
  const codeTabsRef: any = useRef();
  const ScriptSectionRef: any = useRef();
  const isScriptSectionInViewport = useIsInViewport(ScriptSectionRef);
  const MavenSectionRef: any = useRef();
  const isMavenSectionInViewport = useIsInViewport(MavenSectionRef);
  const DivSectionRef: any = useRef();
  const isDicSectionInViewport = useIsInViewport(DivSectionRef);
  const CallbackSectionRef: any = useRef();
  const isCallbackSectionInViewport = useIsInViewport(CallbackSectionRef);
  const ApiRefrenceSectionRef: any = useRef();
  const isApiRefrenceSectionInViewport = useIsInViewport(ApiRefrenceSectionRef);

  let scriptCode = `implementation 'com.github.otpless-tech:otpless-android-sdk:1.1.3`;
  let divCode = `repositories{
  maven{url 'https://jitpack.io'}
}
// sync your gradle to install the SDK`;
  let callbackCode = `<com.otpless.views.WhatsappLoginButton
  android:id="@+id/whatsapp_login"
  app:otpless_link="https://${orgName}.authlink.me"
/>
//Button will only be visible if you have WhatsApp application in your device`;
  let javaCode = `
// Handle Callback
@Override
protected void onCreate(Bundle savedInstanceState) {
  super.onCreate(savedInstanceState);

  // Add this to your activity 
  OtplessManager.getInstance().init(this);

  // Add this to your activity or fragment in which you have added the button
  WhatsappLoginButton button = (WhatsappLoginButton) findViewById(R.id.whatsapp_login);
  button.setResultCallback((data) -> {
    String waid = data.getWaId();
    // Send the waId to your server and pass the waId in getUserDetail API to retrive the users whatsapp mobile number and name. 
    // Handle the signup/signin process
    // ...
  });
}`;
  let kotlinCode = `
// Handle Callback
override fun onCreate(savedInstanceState: Bundle?) {
  super.onCreate(savedInstanceState)

  // Add this to your activity 
  OtplessManager.getInstance().init(this)

  // Add this to your activity or fragment in which you have added the button
  val button = findViewById<View>(R.id.whatsapp_login) as WhatsappLoginButton
  button.setResultCallback { data: OtplessResponse ->
    val waid = data.waId
    // Send the waId to your server and call our getUserDetail API to retrive the mobile number. Then do signup/signin.
  }
}`;
  let requestCode = `
//Call this API from your backend server
curl --location --request POST 'https://${orgName}.authlink.me' \\
--header 'clientId: test1234' \\
--header 'clientSecret: test1234' \\
--header 'Content-Type: application/json' \\
--data-raw '{
  "waId": "test1234"
}'`;
  let responseCode = `
{
  "ok": true, 
  "user": {
    "waNumber": "917948221313",
    "waName": "Tanmay at OTPless",
    "timestamp": "2023-01-04T13:06:24.602660Z"
  }
}`;

  const scrollAccToSpecificElementMap = {
    "Step 1": ScriptSectionRef,
    "Step 2": MavenSectionRef,
    "Step 3": DivSectionRef,
    "Step 4": CallbackSectionRef,
    "Step 5": ApiRefrenceSectionRef,
  };

  useEffect(() => {
    if (getURLParameter("mid") || secureLocalStorage.getItem("mid")) {
      getURLParameter("mid") &&
        secureLocalStorage.setItem("mid", getURLParameter("mid"));
      getURLParameter("mtId") &&
        secureLocalStorage.setItem("mtId", getURLParameter("mtId"));
      window.history.pushState(
        {},
        document.title,
        window.location.href.split("?")[0]
      );
      window
        .fetch("https://metaverse.otpless.app/v1/merchant/getMerchantDetails", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          method: "POST",
          body: JSON.stringify({
            mid: secureLocalStorage.getItem("mid"),
            utm: window.location.href,
            utm_source: getURLParameter("utm_source"),
            utm_medium: getURLParameter("utm_medium"),
            utm_campaign: getURLParameter("utm_campaign"),
          }),
        })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            setOrgName(data?.data?.orgName);
            setOrgDomain(data?.data?.orgDomain);
            setEmailValue(data?.data?.email ?? "");
          } else {
            secureLocalStorage.removeItem("mid");
            ChangeHistory("back", ROUTE_PATH.SAMPLES.LANDING);
          }
        });
    } else {
      ChangeHistory("back", ROUTE_PATH.SAMPLES.LANDING);
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsScrollRouteAllowed(true);
    }, 500);
    if (activeCodeTab === "Step 4") {
      setActiveLanguageTab("Java");
    } else if (activeCodeTab === "Step 5") {
      setActiveLanguageTab("Request");
    }
  }, [activeCodeTab]);

  useEffect(() => {
    if (isScrollRouteAllowed) {
      if (isScriptSectionInViewport) {
        setActiveCodeTab("Step 1");
      } else if (isMavenSectionInViewport) {
        setActiveCodeTab("Step 2");
      } else if (isDicSectionInViewport) {
        setActiveCodeTab("Step 3");
      } else if (isCallbackSectionInViewport) {
        setActiveCodeTab("Step 4");
      } else if (isApiRefrenceSectionInViewport) {
        setActiveCodeTab("Step 5");
      }
    }
  }, [
    isScrollRouteAllowed,
    isScriptSectionInViewport,
    isMavenSectionInViewport,
    isDicSectionInViewport,
    isCallbackSectionInViewport,
    isApiRefrenceSectionInViewport,
  ]);

  //Scroll To Specific element
  const scrollToSpecificElement = (selectedTab) => {
    scrollAccToSpecificElementMap[selectedTab]?.current?.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });
  };

  const MiddleSection = () => {
    return (
      <div className="middle-section text-center">
        <FlexBox
          justifyCenter
          flexColumn
          className="h-100 pd-20 child-section script-section"
          flexBoxRef={ScriptSectionRef}
        >
          <p className="fs-22 font-medium text-left">Install OTPless SDK</p>
          <p className="clr-gray fs-16 text-left">
            Copy-paste the code in your app's{" "}
            <span className="clr-theme">build.gradle </span>dependencies.
          </p>
          <FlexBox alignCenter className="mr-t-10">
            <p className="clr-gray fs-16 text-left">Latest-Tag: </p>
            <Image
              src="https://jitpack.io/v/otpless-tech/otpless-android-sdk.svg"
              className="mr-l-10"
            />
          </FlexBox>
        </FlexBox>
        <FlexBox
          justifyCenter
          flexColumn
          className="h-100 pd-20 child-section script-section"
          flexBoxRef={MavenSectionRef}
        >
          <p className="clr-gray fs-16 text-left">
            Copy-paste the code in your app's
            <span className="clr-theme"> settings.gradle </span>in
            <span className="clr-theme"> dependencyResolutionManagement </span>
          </p>
        </FlexBox>
        <FlexBox
          justifyCenter
          flexColumn
          className="h-100 pd-20 child-section div-section"
          flexBoxRef={DivSectionRef}
        >
          <p className="fs-22 font-medium text-left">Create Button</p>
          <p className="clr-gray fs-16 text-left">
            Copy-paste the code in your
            <span className="clr-theme">
              {" "}
              activity/fragment layout xml file{" "}
            </span>{" "}
            to create "WhatsApp Login" button on your login page
          </p>
        </FlexBox>
        <FlexBox
          justifyCenter
          flexColumn
          className="h-100 pd-20 child-section callback-section"
          flexBoxRef={CallbackSectionRef}
        >
          <p className="fs-22 font-medium text-left">Do Signup/Signin</p>
          <p className="clr-gray fs-16 text-left">
            Copy-paste the code in your{" "}
            <span className="clr-theme"> activity xml file</span>. Once user
            redirected to your app, you will get the waId, then do
            signup/signin.
          </p>
        </FlexBox>
        <FlexBox
          justifyCenter
          flexColumn
          className="h-100 pd-20 child-section callback-section"
          flexBoxRef={ApiRefrenceSectionRef}
        >
          <p className="fs-22 font-medium text-left">Get user details API</p>
          <p className="clr-gray fs-16 text-left">
            Exchange
            <span className="clr-theme"> waId </span> for user's WhatsApp number
            and name.
          </p>
          <Button
            text="Get your API keys"
            className={cx(
              window.screen.width > 768 ? "w-40" : "w-50",
              "mr-t-10 pd-10"
            )}
            variant="outline"
            onClick={() => {
              setApiKeysModalVisiblity(true);
            }}
          />
        </FlexBox>
        {/* <FlexBox alignCenter className="h-5p disabled o-0 pd-20"></FlexBox> */}
      </div>
    );
  };

  const BottomSection = () => {
    return (
      <FlexBox
        justifyBetween
        flexColumn
        className="bottom-section clr-white pd-20 pos-rel"
      >
        <div className="h-70p w-100">
          <FlexBox
            alignCenter
            className="clr-white code-tabs mr-b-20 pos-rel"
            flexBoxRef={codeTabsRef}
          >
            <p
              className={cx(
                activeCodeTab === "Step 1" && "active",
                "fs-14 full-border pd-v-5 pd-h-10 br-9 clicking-animation"
              )}
              onClick={() => {
                setActiveCodeTab("Step 1");
                scrollToSpecificElement("Step 1");
                setIsScrollRouteAllowed(false);
              }}
            >
              Step 1
            </p>
            <p
              className={cx(
                activeCodeTab === "Step 2" && "active",
                "fs-14 full-border pd-v-5 pd-h-10 br-9 clicking-animation"
              )}
              onClick={() => {
                setActiveCodeTab("Step 2");
                scrollToSpecificElement("Step 2");
                setIsScrollRouteAllowed(false);
              }}
            >
              Step 2
            </p>
            <p
              className={cx(
                activeCodeTab === "Step 3" && "active",
                "fs-14 full-border pd-v-5 pd-h-10 br-9 clicking-animation"
              )}
              onClick={() => {
                setActiveCodeTab("Step 3");
                scrollToSpecificElement("Step 3");
                setIsScrollRouteAllowed(false);
              }}
            >
              Step 3
            </p>
            <p
              className={cx(
                activeCodeTab === "Step 4" && "active",
                "fs-14 full-border pd-v-5 pd-h-10 br-9 clicking-animation"
              )}
              onClick={() => {
                setActiveCodeTab("Step 4");
                scrollToSpecificElement("Step 4");
                setIsScrollRouteAllowed(false);
              }}
            >
              Step 4
            </p>
            <p
              className={cx(
                activeCodeTab === "Step 5" && "active",
                "fs-14 full-border pd-v-5 pd-h-10 br-9 clicking-animation"
              )}
              onClick={() => {
                setActiveCodeTab("Step 5");
                scrollToSpecificElement("Step 5");
                setIsScrollRouteAllowed(false);
              }}
            >
              Step 5
            </p>
          </FlexBox>
          {activeCodeTab === "Step 4" && (
            <FlexBox className="language-tabs code-tabs">
              <p
                className={cx(
                  activeLanguageTab === "Java" && "active",
                  "fs-12 full-border pd-v-5 pd-h-10 br-9 clicking-animation"
                )}
                onClick={() => {
                  setActiveLanguageTab("Java");
                }}
              >
                Java
              </p>
              <p
                className={cx(
                  activeLanguageTab === "Kotlin" && "active",
                  "fs-12 full-border pd-v-5 pd-h-10 br-9 clicking-animation"
                )}
                onClick={() => {
                  setActiveLanguageTab("Kotlin");
                }}
              >
                Kotlin
              </p>
            </FlexBox>
          )}
          {activeCodeTab === "Step 5" && (
            <FlexBox className="language-tabs code-tabs">
              <p
                className={cx(
                  activeLanguageTab === "Request" && "active",
                  "fs-12 full-border pd-v-5 pd-h-10 br-9 clicking-animation"
                )}
                onClick={() => {
                  setActiveLanguageTab("Request");
                }}
              >
                Request
              </p>
              <p
                className={cx(
                  activeLanguageTab === "Response" && "active",
                  "fs-12 full-border pd-v-5 pd-h-10 br-9 clicking-animation"
                )}
                onClick={() => {
                  setActiveLanguageTab("Response");
                }}
              >
                Response
              </p>
            </FlexBox>
          )}
          <Code
            code={
              activeCodeTab === "Step 1"
                ? scriptCode
                : activeCodeTab === "Step 2"
                ? divCode
                : activeCodeTab === "Step 3"
                ? callbackCode
                : activeCodeTab === "Step 5"
                ? activeLanguageTab === "Request"
                  ? requestCode
                  : responseCode
                : activeLanguageTab === "Java"
                ? javaCode
                : kotlinCode
            }
            language={activeCodeTab === "Step 5" ? "java" : "java"}
          />
        </div>
        <FlexBox alignEnd className="h-15p w-100">
          <Button
            text={copyButtonText}
            className="w-100 fs-14"
            onClick={() => {
              copyText(
                activeCodeTab === "Step 1"
                  ? scriptCode
                  : activeCodeTab === "Step 2"
                  ? divCode
                  : activeCodeTab === "Step 3"
                  ? callbackCode
                  : activeCodeTab === "Step 5"
                  ? activeLanguageTab === "Request"
                    ? requestCode
                    : responseCode
                  : activeLanguageTab === "Java"
                  ? javaCode
                  : kotlinCode
              );
              setCopyButtonText("Copied");
              setTimeout(() => {
                setCopyButtonText("Copy Code");
              }, 2000);
            }}
          />
        </FlexBox>
      </FlexBox>
    );
  };

  //Return UI
  return (
    <Screen
      className="android-screen"
      screenAnimationClass="no-animation"
      hasHeader
      customHeaderDetails={
        <Button
          variant="outline"
          className="fs-10 pd-5 w-30"
          text="Platforms"
          onClick={() => {
            ChangeHistory("back", ROUTE_PATH.PLATFORM.HOME);
          }}
        />
      }
    >
      <div className="h-100 w-100 overflow-hdn">
        {MiddleSection()}
        {BottomSection()}
        <Modal
          visible={apiKeysModalVisiblity}
          className="api-keys-modal"
          onClose={() => {
            setApiKeysModalVisiblity(false);
          }}
        >
          <FlexBox justifyBetween flexColumn className="clr-black pd-20">
            <p className="fs-18 font-medium">
              We'll send the API Keys to your email
            </p>
            <Input
              type="email"
              onChange={({ target }) => {
                setEmailValue(target.value);
              }}
              value={emailValue}
              placeholder="Enter your email address"
              className="mr-v-20 fs-16"
            />
            <Button
              text={
                showButtonLoader ? (
                  <FlexBox alignCenter justifyCenter>
                    <div className="loader"></div>
                  </FlexBox>
                ) : (
                  <FlexBox alignCenter justifyCenter className="cta-text">
                    <p className="font-medium">Get API Keys</p>
                  </FlexBox>
                )
              }
              className="w-100 fs-16 mr-t-10"
              onClick={() => {
                if (validateEmail(emailValue)) {
                  const subDomain = emailValue.split("@")[1];
                  if (subDomain === orgDomain) {
                    setButtonShowLoader(true);
                    window
                      .fetch(`https://${orgName}.authlink.me/metaverse`, {
                        headers: {
                          Accept: "application/json",
                          "Content-Type": "application/json",
                        },
                        method: "POST",
                        body: JSON.stringify({
                          email: emailValue,
                          api: "send-email",
                          utm: window.location.href,
                          utmSource: getURLParameter("utm_source"),
                          utmMedium: getURLParameter("utm_medium"),
                          utmCampaign: getURLParameter("utm_campaign"),
                          utmCreative: getURLParameter("utm_creative"),
                        }),
                      })
                      .then((res) => res.json())
                      .then((data) => {
                        setButtonShowLoader(false);
                        if (data.success) {
                          toast.success(
                            "We've sent the API Keys. Please check your email"
                          );
                          setApiKeysModalVisiblity(false);
                        } else {
                          toast.error("Something went wrong! Please try again");
                        }
                      })
                      .catch(() => {
                        setButtonShowLoader(false);
                      });
                  } else {
                    toast.error(`Please enter a valid ${orgName} email`);
                  }
                } else {
                  toast.error("Please enter valid work email");
                }
              }}
              disabled={showButtonLoader}
            />
          </FlexBox>
        </Modal>
      </div>
    </Screen>
  );
};

export default Landing;
